module.exports = __webpack_public_path__ + "img/Game_target_Z-05.e83d5399.png";